import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase } from 'lodash';
import { myListTimeSeriess } from '../graphql/my.queries';

// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Symbol, Frequency, CsvFile, RiskDriver, NextStepModel) => {
  const [symbol, setSymbol] = useState(Symbol);
  const [frequency, setFrequency] = useState(Frequency);
  const [csvFile, setCsvFile] = useState(CsvFile);
  const [riskDriver, setRiskDriver] = useState(RiskDriver);
  const [nextStepModel, setNextStepModel] = useState(NextStepModel);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'restapimeucci';
  const path = '/data-process/quest'; //quest
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      symbol: symbol,
      csvFile: csvFile,
      riskDriver: riskDriver,
      nextStepModel: nextStepModel
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));
        
        // reformat response.data.output to columns
        var date_arr = [];
        var value_arr = [];
        var riskDriver_arr = [];
        var invariant_arr = [];
        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.Date);
          value_arr.push(item.Value);
          riskDriver_arr.push(item.RiskDriver);
          invariant_arr.push(item.Invariant);
        });

        // ellipse coords for invariance test
        var x_arr = [];
        var y_arr = [];
        JSON.parse(response.data.ellipse_coords).forEach((item) => {
          x_arr.push(item.x);
          y_arr.push(item.y);
        });
        
        // ks invariance test
        var ks_statistic = response.data.ks_statistic;
        var ks_critical_value = response.data.ks_critical_value;
        var epsi_a = [];
        var epsi_b = [];
        var cdf_aa = [];
        var cdf_bb = [];
        JSON.parse(response.data.ks_coords).forEach((item) => {
          epsi_a.push(item.epsi_a);
          epsi_b.push(item.epsi_b);
          cdf_aa.push(item.cdf_aa);
          cdf_bb.push(item.cdf_bb);
        });
        var band_up = [];
        var band_low = [];
        JSON.parse(response.data.ks_bands).forEach((item) => {
          band_up.push(item.band_up);
          band_low.push(item.band_low);
        });

/*         console.log(ks_statistic);
        console.log(ks_critical_value);
        console.log(band_up);
        console.log(band_low);
        console.log(cdf_aa);
        console.log(cdf_bb); */
        setDataCols({'Date': date_arr, 'Value': value_arr, 'RiskDriver': riskDriver_arr, 'Invariant': invariant_arr,
          'EllipseX': x_arr, 'EllipseY':y_arr, 'KsStatistic': ks_statistic, 'KsCriticalValue': ks_critical_value, 'KsEpsiA': epsi_a,
          'KsEpsiB': epsi_b, 'KsCdfAa': cdf_aa, 'KsCdfBb': cdf_bb, 'KsBandUp': band_up, 'KsBandLow': band_low
        });

      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (symbol !== "" && riskDriver !== "" && nextStepModel !== "") {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [symbol, riskDriver, nextStepModel]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setSymbol, setFrequency, setCsvFile, setRiskDriver, setNextStepModel];
};


export default function Quest() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [symbol, setSymbol] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [riskDriver, setRiskDriver] = useState("");
  const [nextStepModel, setNextStepModel] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(false);
  const [riskDriverSelected, setRiskDriverSelected] = useState(false);
  const [nextStepModelSelected, setNextStepModelSelected] = useState(false);

  const [{ dataCols, dataRows, isComputing, isError }, 
    setSymbolArg, setFrequencyArg, setCsvFileArg, setRiskDriverArg, setNextStepModelArg] = useRestApi(
      symbol, frequency, csvFile, riskDriver, nextStepModel);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        break;
      case "selectRiskDriver":
        //setRiskDriver(event.target.value);
        setRiskDriverSelected(true);
        break;
      case "selectNextStepModel":
        //setRiskDriver(event.target.value);
        setNextStepModelSelected(true);
        break;
      default:
        console.log("No input change.");
        break;
    }
    //console.log("Input changed: " + event.target.id + " - " + event.target.value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected) && (riskDriverSelected) && (nextStepModelSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setSymbol(timeSeriesParams[0]);
    setFrequency(timeSeriesParams[1]);
    setCsvFile(timeSeriesParams[2]);
    setSymbolArg(timeSeriesParams[0]);
    setFrequencyArg(timeSeriesParams[1]);
    setCsvFileArg(timeSeriesParams[2]);
    setRiskDriver(document.getElementById('selectRiskDriver').value);
    setRiskDriverArg(document.getElementById('selectRiskDriver').value);
    setNextStepModel(document.getElementById('selectNextStepModel').value);
    setNextStepModelArg(document.getElementById('selectNextStepModel').value);
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="chart">
          <Tab eventKey="chart" title="Chart">
            <br />
            <QuestCharts dataCols={props.dataCols}/>
          </Tab>
          <Tab eventKey="data" title="Data">
            <br />
            <DataTable dataRows={props.dataRows}/>
          </Tab>
          <Tab eventKey="desc" title="Description">
            <br />  
            <Table size="sm" className="table table-borderless">
              <tbody>
                <tr>
                  <td className="col-md-3"><strong>Symbol:</strong></td>
                  <td className="col-md-9">{props.symbol}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Frequency:</strong></td>
                  <td className="col-md-9">{startCase(props.frequency)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Data File:</strong></td>
                  <td className="col-md-9">{props.csvFile}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Risk Driver:</strong></td>
                  <td className="col-md-9">{startCase(props.riskDriver)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Next Step Model:</strong></td>
                  <td className="col-md-9">{startCase(props.nextStepModel)}</td>
                </tr>
                <tr>
                  <td className="col-md-3"><strong>Summary:</strong></td>
                  <td className="col-md-9">
                  {/* Data has {props.dataCols.Date.length} rows and {Object.keys(props.dataCols).length} columns:<br /> */}
                  Data has {props.dataCols.Date.length} rows and 4 columns:<br />
                    <ul>
{/*                     {
                      Object.entries(props.dataCols).map(([key, value], index) => {
                        return(
                          <li key={index.toString()} value={key} data-type="text">{startCase(key)}</li>
                        )
                    })} */}
                      <li>Date</li>
                      <li>Value</li>
                      <li>Risk Driver</li>
                      <li>Invariant</li>
                    </ul>                
                  </td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>
    );
  }
  
  function QuestCharts(props) {
    // https://codepen.io/plotly/pen/KpLVzv
    // todo set own ticks?
    //let range = (Math.max(...current) - Math.min(...current)) / 10;
    //console.log(props.dataCols.EllipseX.length);
    
    let lengthArray = props.dataCols.Invariant.length
    /*let half = Math.ceil(lengthArray / 2);    
    const firstHalf = props.dataCols.Invariant.slice(0, half);
    const secondHalf = props.dataCols.Invariant.slice(-half); */
  
    // ellipsoid test
    let current = props.dataCols.Invariant.slice(1, lengthArray);
    let lag1 = props.dataCols.Invariant.slice(0, lengthArray - 1);

    // ks test
    var epsiSort = new Float64Array([...new Set(props.dataCols.Invariant)]).sort();
    //console.log(props.dataCols.KsEpsiA);
    //console.log(props.dataCols.KsCdfAa);

/*     [
      '#1f77b4',  # muted blue
      '#ff7f0e',  # safety orange
      '#2ca02c',  # cooked asparagus green
      '#d62728',  # brick red
      '#9467bd',  # muted purple
      '#8c564b',  # chestnut brown
      '#e377c2',  # raspberry yogurt pink
      '#7f7f7f',  # middle gray
      '#bcbd22',  # curry yellow-green
      '#17becf'   # blue-teal
  ] */
    var trace9 = {
      x: props.dataCols.KsEpsiB,
      y: props.dataCols.KsCdfBb,
      type: "scatter",
      name: 'CDF 2nd Sample',
      mode: 'markers',
      marker: {
        size: 4,
        color: '#1f77b4',
      },
    };

    var trace8 = {
      x: props.dataCols.KsEpsiA,
      y: props.dataCols.KsCdfAa,
      type: "scatter",
      name: 'CDF 1st Sample',
      mode: 'markers',
      marker: {
        size: 4,
        color: '#ff7f0e',
      },
    };

    var trace6 = {
      x: epsiSort,
      y: props.dataCols.KsBandUp,
      name: 'Upper Confidence Band',
      mode: 'lines',
      line: {
        dash: 'dot',
        width: 1,
        color: 'gray'
      },
    };

    var trace7 = {
      x: epsiSort,
      y: props.dataCols.KsBandLow,
      name: 'Lower Confidence Band',
      mode: 'lines',  
      line: {
        dash: 'dot',
        width: 1,
        color: 'gray'
      },
    };

    var trace1 = {
      x: props.dataCols.EllipseX,
      y: props.dataCols.EllipseY,
      marker: {
        color: '#d62728',
      },
    };
    var trace3 = {
      x: props.dataCols.KsEpsiA,
      name: "1st Sample",
      type: "histogram",
      marker: {
        color: '#ff7f0e', // safety orange
      },
    };
    var trace4 = {
      x: props.dataCols.KsEpsiB,
      name: "2nd Sample",
      type: "histogram",
      marker: {
        color: '#1f77b4', //muted blue
      },
      xaxis: 'x2',
      yaxis: 'y',
    };
  
    var trace5 = {
      x: lag1,
      y: current,
      mode: 'markers',
      type: 'scatter',
    };
    var trace5a = {
      x5: lag1,
      y5: current,
      mode: 'markers',
      type: 'scatter',
    };

    return (
      <>
      <div>
      <div>
        <Plot
          data={[trace5, trace1]}
          config={ {responsive: true} }
          layout={ {title: 'Ellipsoid Invariance Test - ' + symbol + ' Current vs Lagged',
                    xaxis_title: "X Axis Title",
                    yaxis_title: "Y Axis Title",
                    showlegend: false,
                    xaxis: {
                      //ticklabelposition: "inside right",
                      tick0: 0,
                      //dtick: 0.05
                    },
                    yaxis: {
                      scaleanchor: "x",
                      scaleratio: 1,
                      tick0: 0,
                      //ticklabelposition: "inside top"
                      //dtick: 0.05
                    }
          } }
        />
        <p>The red ellipsoid should be circular in shape as well as the cloud of data points.  The data should also not show distinct clusters.</p> 
      </div>
      <hr className="featurette-divider" />
      <Plot
          data={[trace3, trace4]}
          config={ {responsive: true} }
          layout={ {title: 'Kolmogorov–Smirnov Invariance Test - ' + symbol,
                  //width: 500, // 700
                  height: 300, // 450
                  margin: {
                    l: 80, //80
                    r: 80, //80
                    b: 30, //80
                    t: 100, //100
                    pad: 0 //0
                  },
                    grid: {
                      rows: 1, 
                      columns: 2, 
                      subplots:[['xy', 'x2y']],
                      //roworder:'bottom to top',
                      //pattern: 'independent'
                    },
                    showlegend: false,
/*                     xaxis: {
                      title: {
                        text: '1st Sample',
                      },
                    }
                    xaxis2: {
                      title: {
                        text: '2nd Sample',
                      },
                    } */
              } }
        /> 
        <Plot
          data={[trace6, trace7, trace8, trace9]}
          config={ {responsive: true} }
          layout={ {//title: 'Kolmogorov–Smirnov Invariance Test - ' + symbol,
                    margin: {
                      l: 80, //80
                      r: 80, //80
                      b: 80, //80
                      t: 0, //100
                      pad: 0 //0
                    },
                    showlegend: false,
                    xaxis: {
                      zeroline: false
                    },
                    yaxis: {
                      zeroline: false
                    },
          } }
        /> 
        <p>K-S Statistic: {Number.parseFloat(props.dataCols.KsStatistic).toFixed(5)}<br />
          K-S Critical Value (95% Confidence Level): {Number.parseFloat(props.dataCols.KsCriticalValue).toFixed(5)}</p>
          { props.dataCols.KsStatistic < props.dataCols.KsCriticalValue ? (
            <p>OK passed test (did not reject the null hypothesis that the 2 samples are drawn from the same distribution).</p>
          ) : (
            <p>NOK failed test (rejected the null hypothesis that the 2 samples are drawn from the same distribution).</p>
          )}
      </div>
      <hr className="featurette-divider" />
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Invariant,
              type: 'line',
              mode: 'markers',
              marker: {color: 'Orange'},
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Invariants'
          } }
        /> 
      </div>
      <hr className="featurette-divider" />


      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.RiskDriver,
              type: 'line',
              mode: 'lines',
              marker: {color: 'green'},
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Risk Driver '} }
        /> 
      </div>
      <hr className="featurette-divider" />
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Value,
              type: 'line',
              mode: 'lines',
              marker: {color: 'black'},
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Value'} }
        /> 
      </div>
      </>
    );  
  }
  
  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    const dataTableColumns = [
      {
        dataField: "Date",
        text: "Date",
        sort: true
      },
      {
        dataField: "Value",
        text: "Value",
      },
      {
        dataField: "RiskDriver",
        text: "Risk Driver"
      },
      {
        dataField: "Invariant",
        text: "Invariant"
      }      
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }


  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Quest for Invariance</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries">
                          <Form.Label>Time series:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="" key="0">Select time series...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.symbol + '|' + value.frequency + '|' + value.csvFile} data-type="text">{value.symbol}_{value.frequency}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectRiskDriver">
                          <Form.Label>Risk Driver:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select risk driver...</option>
                            <option value="value">Value</option>
                            <option value="logValue">Log Value</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectNextStepModel">
                          <Form.Label>Next Step Model:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select next step model...</option>
                            <option value="randomWalk">Random Walk</option>
                            <option value="Garch11">GARCH(1,1)</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                          <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                          >
                            Quest for Invariance
                          </LoaderButton>
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} symbol={symbol} frequency={frequency} csvFile={csvFile} 
                riskDriver={riskDriver} nextStepModel={nextStepModel}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}